var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader'),_c('navbar'),_c('section',{staticClass:"base-section",staticStyle:{"min-height":"800px"}},[_c('div',{staticClass:"container"},[_vm._t("default")],2)]),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }